import { render, staticRenderFns } from "./ReferenciaBancariaPage.vue?vue&type=template&id=b54bfc98&scoped=true&"
import script from "./ReferenciaBancariaPage.vue?vue&type=script&lang=js&"
export * from "./ReferenciaBancariaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54bfc98",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/ReferenciaBancariaPage.vue
// module id = 223
// module chunks = 14